const GridButton = ({ data }: any, callbackFunc: Function, caption?: string, className?: string) => {
  return (
    <button
      className={`inline-block p-1.5 font-medium text-white bg-green-400 rounded ${className}`}
      onClick={e => (e ? callbackFunc(e, data) : null)}
    >
      {caption ?? data.column.caption}
    </button>
  );
};

export default GridButton;
